import { useDispatch } from 'src/store';
import { actions } from 'src/store/navbar';

export const useHideNavbar = () => {
  const dispatch = useDispatch();

  return {
    hideAll: () => {
      dispatch(actions.hideAll());
    },
    hideCuisineFilters: () => {
      dispatch(actions.hideCuisineFilters());
    },
    hideDatePicker: () => {
      dispatch(actions.hideDatePicker());
    },
    hideDietaryFilters: () => {
      dispatch(actions.hideDietaryFilters());
    },
    hideMoreFilters: () => {
      dispatch(actions.hideMoreFilters());
    },
    hideProteinFilters: () => {
      dispatch(actions.hideProteinFilters());
    },
    hideSearch: () => {
      dispatch(actions.hideSearch());
    },
    hideSubCuisineFilters: () => {
      dispatch(actions.hideSubCuisineFilters());
    },
  };
};
